import React from "react";

export default function LogoComponent(props) {
  const { item, img, path } = props;
  //const { item } = props;
  return (
    <div className="slide">
      {item?.company_logo ? (
        <img
          src={path + encodeURI(item?.company_logo)}
          alt={item?.company_name}
        />
      ) : (
        //   <img src={img} alt={item?.company_name} />
        <i className="fa fa-image fa-4x" title={item?.company_name}></i>
      )}
    </div>
  );
}
